import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import BaseCard from './BaseCard';
import Text from './Text';
import Title from './Title';
import Icon from './Icon';
import styled, { css } from 'styled-components';
import { flexColumn, flexRow } from '../../constants/styles';
import { Accordion } from 'react-accessible-accordion';
import FAQuestion from '../landing/FAQuestion';
import SegmentedText from './SegmentedText';

const StyledMid = styled.div`
  ${flexRow}
  margin-top: 20px;
  justify-content: space-evenly;
`;

const StyledStatus = styled.div`
  ${flexColumn}
  text-align: center;
  justify-content: center;
  align-content: center;
`;

function RiskFactor({ riskFactor }) {
  const { title, icon, color, currentStatus, explanation, notes } = riskFactor;
  return (
    <BaseCard
      maxWidth={350}
      styles={css`
        padding: 20px;
        margin-bottom: 20px;
      `}
    >
      <Title level={4} align="center">
        {title}
      </Title>

      <StyledMid>
        <Icon icon={icon} size={45} color="black" />
        <StyledStatus>
          <Text type="body1">Estatus:</Text>
          <Text type="body2" color={color} medium>
            {currentStatus}
          </Text>
        </StyledStatus>
      </StyledMid>
      <Accordion accordion={false} style={{ width: '100%', marginTop: '10px', maxWidth: '750px' }}>
        <FAQuestion
          question={{
            question: '¿Qué es esto?',
            answer: explanation,
            metric: 'Cafecin | CuentameMas | No me identifico',
          }}
          expanded={false}
          questionLevel={4}
          textType="body2"
          borderBottom
        />
      </Accordion>
      {notes && (
        <Fragment>
          <Text type="body2" style={{ marginTop: '10px' }} bold>
            Notas:
          </Text>
          <SegmentedText
            styles={css`
              margin-top: 5px;
            `}
            text={notes}
            teaserTextSize={65}
            textType="body2"
          />
        </Fragment>
      )}
    </BaseCard>
  );
}

RiskFactor.propTypes = {};
RiskFactor.defaultPropTypes = {
  notes: 'Todo en orden',
};

export default RiskFactor;
